import axios from 'axios';
import { update } from 'lodash';
import orderby from 'lodash/orderBy';


// variables needes in outside scope
let jsPostsLoaded = false;
let jsInitialPostsCount;
let jsPostSorting = 'newest';
let printJsPosts;
let jsPostsCount;
let jsPostsData = [];
let jsPostsBankSize;
let jsPostsCheckedCategories = [];
let jsPostsDropdownCategories = [];
let jsPostsCheckedTags = [];
let jsPostsYear;
let hasHashFilters = false;
let endpoint = '';
let postsFormat = '';

// get years dropdown
const winnersYearSelect = document.querySelector('.js-posts__select-year');
// if theres a years dropdown
if (winnersYearSelect) {
    // init jsPostsYear
    jsPostsYear = winnersYearSelect.value;
    console.log('jsPostsYear:' + jsPostsYear);
    // if year is empty, sort by year descending
    if (jsPostsYear == '') {
        jsPostSorting = 'yearDesc';
        console.log('jsPostsYear, sort by ' + jsPostSorting);
    }
}

// sort advisors by menu order
const acceleratorAdvisors = document.querySelector('.accelerator-advisors');
if (acceleratorAdvisors) {
    jsPostSorting = 'menu';
}


// URL parameters
const setUrlParameters = () => {

    let urlParameterGroups = [];

    // append sorting
    // let urlParameters = '?sort=' + jsPostSorting;
    if (jsPostSorting != 'newest') {
        urlParameterGroups.push('sort=' + jsPostSorting);
    }

    // append categories
    if (jsPostsCheckedCategories.length > 0 || jsPostsDropdownCategories.length > 0) {
        let categoryGroups = [];
        // get checkbox categories
        categoryGroups.push(jsPostsCheckedCategories.map(o => o.slug).join());
        // get dropdown categories
        categoryGroups.push(jsPostsDropdownCategories.map(o => o.slug).join());
        // append all categories
        // urlParameters += '&cat=' + categoryGroups.join('');
        urlParameterGroups.push('cat=' + categoryGroups.join(''));
    }
    // append tags
    if (jsPostsCheckedTags.length > 0) {
        // urlParameters += '&tag=' + jsPostsCheckedTags.map(o => o.slug).join();
        urlParameterGroups.push('tag=' + jsPostsCheckedTags.map(o => o.slug).join());
    }
    // append year
    if (jsPostsYear > 0) {
        // do not use 'year' is reserved by wordpress
        // urlParameters += '&selected_year=' + jsPostsYear;
        urlParameterGroups.push('selected_year=' + jsPostsYear);
    }

    // concatenate all parameter groups
    const finalUrlParameters = urlParameterGroups.length > 0 ? '?' + urlParameterGroups.join('&') : '';

    if (finalUrlParameters != '') {
        history.pushState({ page: 'brain-health-library' }, "Sorting and filtering", finalUrlParameters);
    } else {
        history.replaceState({}, '', location.pathname);
    }

}

// Posts sorting
const updatePostSorting = value => {
    console.log('updatePostSorting(' + value + ')');
    jsPostSorting = value;
    // jsPostsCount = jsInitialPostsCount;
    printJsPosts();
    setUrlParameters();
}

const setCategoryFromSelect = (value, label) => {
    if (value == 'all') {
        jsPostsDropdownCategories = [];
    } else {
        jsPostsDropdownCategories = [{
            "slug": value,
            "title": label
        }];
    }
    printJsPosts();
    setUrlParameters();
}

const setYearFromSelect = (value) => {
    jsPostsYear = value;
    printJsPosts();
    setUrlParameters();
    console.log('setYearFromSelect(' + value + ')');
}

const encodeHTML = s => {
    return s.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
}

// find js posts element
const jsPosts = document.getElementById('js-posts');

if (jsPosts) {

    // check for hashes
    const queryString = window.location.search;
    if (queryString.length > 0) {
        const urlParams = new URLSearchParams(queryString);
        // sorting
        const sort = urlParams.get('sort');
        if (sort) {
            jsPostSorting = sort;
        }
        // tags
        const tag = urlParams.get('tag');
        if (tag) {
            hasHashFilters = true;
            // get urlTags array from tag url parameter
            const urlTags = tag.split(',');
            // get all tag checkboxes
            const tagCheckboxes = Array.from(document.querySelectorAll('.js-posts__filters-tag'));
            // for each tag in array, 
            urlTags.forEach(urlTag => {
                // find matching checkbox
                const tagCheckbox = tagCheckboxes.find(item => {
                    return urlTag == item.value;
                });
                if (tagCheckbox) {
                    // check the matching checkbox
                    tagCheckbox.checked = true;
                    // add tags to jsPostsCheckedTags;
                    jsPostsCheckedTags.push({
                        "slug": tagCheckbox.value,
                        "title": tagCheckbox.dataset.title
                    });
                }
            });
        }
        // categories
        const cat = urlParams.get('cat');
        if (cat) {
            hasHashFilters = true;
            // get urlTags array from cat url parameter
            const urlCategories = cat.split(',');
            // get all category checkboxes
            const categoryCheckboxes = Array.from(document.querySelectorAll('.js-posts__filters-category'));
            const categoryOptions = Array.from(document.querySelectorAll('.js-posts__select-category-option'));
            // for each category in array, 
            urlCategories.forEach(urlCategory => {
                // find matching checkbox
                const categoryCheckbox = categoryCheckboxes.find(item => {
                    return urlCategory == item.value;
                });
                if (categoryCheckbox) {
                    // check the matching checkbox
                    categoryCheckbox.checked = true;
                    // add tags to jsPostsCheckedCategories;
                    jsPostsCheckedCategories.push({
                        "slug": categoryCheckbox.value,
                        "title": categoryCheckbox.dataset.title
                    });
                }
                // find matching select options
                const categoryOption = categoryOptions.find(item => {
                    return urlCategory == item.value;
                });
                if (categoryOption) {
                    // select the matching option
                    categoryOption.selected = 'selected';
                    // add tags to jsPostsCheckedCategories;
                    jsPostsDropdownCategories.push({
                        "slug": categoryOption.value,
                        "title": categoryOption.innerHTML
                    });
                }

            });
        }

        // year
        const year = urlParams.get('selected_year');
        if (year) {
            const yearOptions = Array.from(document.querySelectorAll('.js-posts__select-year-option'));
            const yearSelect = yearOptions.find(item => {
                return year == item.value;
            });
            if (yearSelect) {
                // select the matching option
                yearSelect.selected = 'selected';
                jsPostsYear = yearSelect.value;
            }
        }
    }

    // filter toggle
    const jsPostsFilters = document.getElementById('js-posts__filters');
    const jsPostsFilterToggle = document.getElementById('js-posts__filter-toggle');
    if (jsPostsFilterToggle && jsPostsFilters) {
        jsPostsFilterToggle.addEventListener('click', event => {
            event.preventDefault();
            toggleFilters();
        });
    }
    const toggleFilters = () => {
        jsPostsFilterToggle.classList.toggle('button--tertiary-icon--active');
        if (jsPostsFilterToggle.classList.contains('button--tertiary-icon--active')) {
            jsPostsFilters.classList.add('js-posts__filters--active');
        } else {
            jsPostsFilters.classList.remove('js-posts__filters--active');
        }
    }
    const closeFilters = () => {
        if (jsPostsFilterToggle) jsPostsFilterToggle.classList.remove('button--tertiary-icon--active');
        if (jsPostsFilters) jsPostsFilters.classList.remove('js-posts__filters--active');
    }


    // posts
    const jsPostsPosts = document.getElementById('js-posts__posts');
    const jsPostsResults = document.getElementById('js-posts__results');
    if (jsPostsPosts) {

        // load from API
        const loadPostsFromApi = postsElement => {
            // get data values
            endpoint = postsElement.dataset.endpoint;
            // init request url with endopint
            let requestUrl = endpoint + '/';
            // add url parameters if available
            requestUrl += postsElement.dataset.urlParameters ? postsElement.dataset.urlParameters : '';
            // manage count
            jsPostsCount = Number(postsElement.dataset.initial);
            jsInitialPostsCount = jsPostsCount;
            jsPostsBankSize = Number(postsElement.dataset.bank);

            // request data
            axios({
                method: 'get',
                url: siteUrl + '/wp-json/endpoints/' + requestUrl
            })
                .then(function (response) {
                    jsPostsData = response.data.posts;
                    jsPostsLoaded = true;
                    printJsPosts();
                    // console.log('success: ' + JSON.stringify(jsPostsData));
                })
                .catch(function (error) {
                    console.log('error: ' + JSON.stringify(error));
                });

            // console.log('loadPostsFromApi: ' + endpoint + ',' + jsPostsCount + ',' + jsPostsBankSize);
        }

        loadPostsFromApi(jsPostsPosts);

    }

    // print js posts
    printJsPosts = () => {
        // console.log('printJsPosts');

        // determine posts format
        switch (endpoint) {
            case 'posts':
                postsFormat = 'cards cards--blog';
                break;
        }

        // get posts template
        const postListHtml = jsPostsHtml();
        // inserts posts html
        jsPostsPosts.innerHTML = `
            <div class="${postsFormat}">
                ${postListHtml}
            </div>
        `;
    }

    const filterPosts = postItem => {
        // console.log('post:' + postItem.id + ', cat:' + postItem.category);
        let itemMatchesFilters = false;
        let evalConditions = [];
        let evalConditionsString = '';
        // filter by cat
        let catConditions = [];
        let catConditionsString = '';

        // add checkbox category conditions
        if (jsPostsCheckedCategories.length > 0) {
            // add a condition for each category
            jsPostsCheckedCategories.forEach(item => {
                catConditions.push('postItem.category.search("' + item.slug + '") !== -1');
            });
        }
        // add dropdown category conditions
        if (jsPostsDropdownCategories.length > 0) {
            // add a condition for each category
            jsPostsDropdownCategories.forEach(item => {
                catConditions.push('postItem.category.search("' + item.slug + '") !== -1');
            });
        }
        // concatenate all category conditions with || logic
        if (jsPostsCheckedCategories.length > 0 || jsPostsDropdownCategories.length > 0) {
            // matching items need any of the categories
            catConditionsString = catConditions.join(' || ');
            // add category conditions to master eval conditions
            evalConditions.push(catConditionsString);
        }

        // filter by tag
        let tagConditions = [];
        let tagConditionsString = '';
        if (jsPostsCheckedTags.length > 0) {
            // add a condition for each tag
            jsPostsCheckedTags.forEach(item => {
                tagConditions.push('postItem.tags.search("' + item.slug + '") !== -1');
            });
            // concatenate tag conditions with || logic
            // matching items need any of the tags
            tagConditionsString = tagConditions.join(' || ');
            // add tag conditions to master eval conditions
            evalConditions.push(tagConditionsString);
        }

        // filter by year
        if (jsPostsYear > 0) {
            // add year condition to master eval conditions
            evalConditions.push('postItem.year.search("' + jsPostsYear + '") !== -1');
        }

        // concatenate master eval conditions with && logic
        // matching items need to match a category and a tag
        if (evalConditions.length > 0) {
            evalConditionsString += '(';
            evalConditionsString += evalConditions.join(') && (');
            evalConditionsString += ')';
        }
        // console.log('evalConditionsString:' + evalConditionsString);

        // item matches if there are no conditions or if master eval conditions are true
        itemMatchesFilters = evalConditionsString == '' || eval(evalConditionsString) ? true : false;
        return itemMatchesFilters;
    }

    const cardsItem = item => {
        const hasExternalLink = item.custom_fields && item.custom_fields.external_url ? true : false;
        const itemLink = hasExternalLink ? item.custom_fields.external_url : item.permalink;
        const itemTarget = hasExternalLink ? '_blank' : '_top';
        const itemAuthor = item.custom_fields && item.custom_fields.authors && item.custom_fields.authors[0] ? item.custom_fields.authors[0].post_title : item.author;
        return (`
            <div class="card">

                    ${item.thumbnail ? `
                    <a href="${itemLink}" target="${itemTarget}" class="card__image zoom-image">
                        <img class="bg-image" src="${item.thumbnail.thumbnail}" alt="${encodeHTML(item.thumbnail.alt)}"/>
                    </a>                            
                    ` : ``}

                    <div class="card__content">
                        ${item.category && item.category_title && endpoint == 'posts' ? `<h6 class="card__category small-title"><a href="${siteUrl}/blog/?cat=${item.category}">${item.category_title}</a></h6>` : ``}
                        <div class="card__date body-copy body-copy--small">${item.date}</div>
                        <h2 class="card__heading article-heading"><a href="${itemLink}" target="${itemTarget}">${item.title}</a></h2>
                        ${item.excerpt ? `<div class="card__excerpt body-copy">${item.excerpt}</div>` : ``}
                        <div class="card__cta-wrapper">
                            <a href="${itemLink}" target="${itemTarget}" class="card__cta arrow-cta arrow-cta--blue">
                                Learn More
                                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 570 1000"><polygon points="73 1000 0 927.3 424.8 500 0 72.7 73 0 570 500 "></polygon></svg>
                            </a>
                        </div>                           
                    </div>
            </div>
        `);

        /*


                        ${ item.category == 'workplace-mental-health-blogs' ? `
                    <div class="card__author body-copy body-copy--tertiary">By: ${itemAuthor}</div>
                    ` : ``}    
        
     
        */
    }


    // generate html template
    const jsPostsHtml = () => {
        let sortedPosts;
        // filter posts
        const filteredPosts = jsPostsData.filter(item => {
            return filterPosts(item);
        });

        // sort posts
        console.log('sort posts by:' + jsPostSorting);
        switch (jsPostSorting) {
            case 'newest':
                sortedPosts = orderby(filteredPosts, 'timestamp', 'desc');
                break;
            case 'oldest':
                sortedPosts = orderby(filteredPosts, 'timestamp', 'asc');
                break;
            case 'asc':
                sortedPosts = orderby(filteredPosts, 'title', 'asc');
                break;
            case 'desc':
                sortedPosts = orderby(filteredPosts, 'title', 'desc');
                break;
            case 'yearDesc':
                sortedPosts = orderby(filteredPosts, 'year', 'desc');
                break;
            case 'menu':
                sortedPosts = orderby(filteredPosts, 'menu_order');
                break;
            default:
                sortedPosts = orderby(filteredPosts, 'timestamp', 'desc');
        }

        // handle load more button
        manageLoadMoreVisibility(sortedPosts.length);

        // update results count
        if (jsPostsResults) {
            jsPostsResults.innerHTML = sortedPosts.length + (sortedPosts.length == 1 ? ' Result' : ' Results');
        }

        // print filtered posts
        if (sortedPosts.length > 0) {
            return sortedPosts.join(0).split(0).map((item, i) => {
                if (i < jsPostsCount) {
                    const item = sortedPosts[i];
                    // return HTML depending on endpoint
                    switch (endpoint) {
                        case 'posts':
                            return cardsItem(item);
                            break;
                    }
                }
            }).join('');
        } else {
            // no filtered posts
            return `
                ${ jsPostsLoaded ? `
                    <div class="card card--no-results">
                        <div class="card__content">
                        Sorry! No results found.
                        </div>
                    </div>            
                ` : ``}
            `;
        }
    }

    // Load More
    const jsPostsLoadMoreCta = document.getElementById('js-posts__load-more-cta');
    const jsPostsLoadMoreWrapper = document.getElementById('js-posts__load-more-wrapper');
    if (jsPostsLoadMoreCta) {
        jsPostsLoadMoreCta.addEventListener('click', e => {
            e.preventDefault();
            // increase count
            jsPostsCount += jsPostsBankSize;
            // // reprint posts
            printJsPosts();
        });
    }
    // reveals & hode load more button
    const manageLoadMoreVisibility = (postsCount) => {
        // console.log('manageLoadMoreVisibility() postsCount:' + postsCount + ', jsPostsCount:' + jsPostsCount);
        if (jsPostsLoadMoreWrapper) {
            if (postsCount > jsPostsCount) {
                jsPostsLoadMoreWrapper.classList.add('js-posts__load-more-wrapper--active');
            } else {
                jsPostsLoadMoreWrapper.classList.remove('js-posts__load-more-wrapper--active');
            }
        }
    }


    // filters
    /*
    js-posts__filters-tag
    js-posts__filters-category
    */

    // clear filters

    // unchecks all checkboxes
    const clearFilters = () => {
        const checkboxes = Array.from(document.querySelectorAll('.js-posts__filters-checkbox'));
        if (checkboxes) {
            checkboxes.forEach(item => {
                item.checked = false;
            });
            updateFilters();
        }
    }

    // clear filters button
    const jsPostsFiltersClear = Array.from(document.querySelectorAll('.js-posts__filters-clear'));
    if (jsPostsFiltersClear.length > 0) {
        // clear click
        jsPostsFiltersClear.forEach(item => {
            item.addEventListener('click', e => {
                e.preventDefault();
                clearFilters();
            });
        });
    }


    // clear selected filter
    const clearSelectedFilter = selectedFilter => {
        const checkboxes = Array.from(document.querySelectorAll('.js-posts__filters-checkbox'));
        checkboxes.forEach(item => {
            if (item.value == selectedFilter) {
                item.checked = false;
            }
        });
        updateFilters();
    }



    // apply filters
    const jsPostsFiltersApply = document.getElementById('js-posts__filters-apply');
    if (jsPostsFiltersApply) {
        jsPostsFiltersApply.addEventListener('click', e => {
            e.preventDefault();
            updateFilters();
        });
    }

    const updateFilters = () => {
        applyCategories();
        applyTags();
        jsPostsCount = jsInitialPostsCount;
        setSelectedFilters();
        setUrlParameters();
        printJsPosts();
        closeFilters();
    }

    const applyCategories = () => {
        jsPostsCheckedCategories = [];
        const checkedCategories = Array.from(document.querySelectorAll('.js-posts__filters-category:checked'));
        if (checkedCategories) {
            checkedCategories.forEach(item => {
                jsPostsCheckedCategories.push({
                    "slug": item.value,
                    "title": item.dataset.title
                });
            });
        }
        console.log('applyCategories()' + JSON.stringify(jsPostsCheckedCategories));

    }

    const applyTags = () => {
        jsPostsCheckedTags = [];
        const checkedTags = Array.from(document.querySelectorAll('.js-posts__filters-tag:checked'));
        if (checkedTags) {
            checkedTags.forEach(item => {
                jsPostsCheckedTags.push({
                    "slug": item.value,
                    "title": item.dataset.title
                });
            });
        }
        console.log('applyTags()' + JSON.stringify(jsPostsCheckedTags));

    }


    const jsPostsSelectedFilters = document.getElementById('js-posts__selected-filters');
    const jsPostsSelectedFiltersItems = document.getElementById('js-posts__selected-filters-items');

    const filterItemsHtml = collection => {
        return collection.join(0).split(0).map((taxonomyItem, i) => {
            const thisItem = collection[i];
            return (`
                <div class="js-posts__selected-filters-item">
                    <span class="js-posts__selected-filters-label" data-value="${thisItem.slug}">${thisItem.title}</span>
                    <a href="#" class="js-posts__selected-filters-close" data-value="${thisItem.slug}">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000"><path class="st0" d="M651.6 500l227.4-227.4c27.9-27.9 27.9-73.2 0-101.1l-50.5-50.5c-27.9-27.9-73.2-27.9-101.1 0L500 348.4 272.6 120.9c-27.9-27.9-73.2-27.9-101.1 0l-50.5 50.5c-27.9 27.9-27.9 73.2 0 101.1L348.4 500 120.9 727.4c-27.9 27.9-27.9 73.2 0 101.1l50.5 50.5c27.9 27.9 73.2 27.9 101.1 0L500 651.6l227.4 227.4c27.9 27.9 73.2 27.9 101.1 0l50.5-50.5c27.9-27.9 27.9-73.2 0-101.1L651.6 500z"/></svg>
                    </a>
                </div>
            `);
        }).join('');
    }

    const setSelectedFilters = () => {
        console.log('setSelectedFilters()');
        // update selected filters items
        if (jsPostsSelectedFiltersItems) {
            const jsPostsSelectedTagsHtml = jsPostsCheckedTags.length > 0 ? filterItemsHtml(jsPostsCheckedTags) : '';
            const jsPostsSelectedCategoriesHtml = jsPostsCheckedCategories.length > 0 ? filterItemsHtml(jsPostsCheckedCategories) : '';
            jsPostsSelectedFiltersItems.innerHTML = `
                ${jsPostsSelectedTagsHtml}
                ${jsPostsSelectedCategoriesHtml}
                <a href="#" id="js-posts__filters-item-clear" class="js-posts__filters-item-clear hyperlink hyperlink--secondary">Clear</a>
            `;
        }
        // clear button event listener
        const jsPostsFiltersItemClear = document.getElementById('js-posts__filters-item-clear');
        if (jsPostsFiltersItemClear) {
            jsPostsFiltersItemClear.addEventListener('click', event => {
                event.preventDefault();
                clearFilters();
            });
        }
        // init selected filters click
        const jsPostsSelectedFiltersClose = Array.from(document.querySelectorAll('.js-posts__selected-filters-close'));
        if (jsPostsSelectedFiltersClose.length > 0) {
            // clear click
            jsPostsSelectedFiltersClose.forEach(item => {
                item.addEventListener('click', e => {
                    e.preventDefault();
                    clearSelectedFilter(item.dataset.value);
                });
            });
        }
        // display or hide selected filters
        if (jsPostsSelectedFilters) {
            jsPostsCheckedTags.length + jsPostsCheckedCategories.length > 0 ? jsPostsSelectedFilters.classList.add('js-posts__selected-filters--active') : jsPostsSelectedFilters.classList.remove('js-posts__selected-filters--active');

        }
    }

    if (hasHashFilters) {
        updateFilters();
    }

    // END: if (jsPosts)
}


export {
    updatePostSorting, setCategoryFromSelect, setYearFromSelect
}